<template lang="pug">
div
  app-imovel-denominacao(
    :required="true",
    :imovel="cadastro.imovel"
    tipoCadastro="AFORAMENTO"
  )
  app-matricula-imovel(
    :imovel="cadastro.imovel"
    :required="true",
  )

  app-divider(label="Dados do Título")
  el-row(:gutter="30")
    el-col.inputDiv(:span="8")
      app-label(label="Nome do beneficiário:", :required="false")
      el-input.input(
        v-model="cadastro.imovel.nomeBeneficiarioTitulo",
        name='Nome do beneficiário',
        maxlength="300"
      )
  app-documentos(
    :maxSize='25000',
    :valid-extensions="['pdf','rar', 'zip']",
    :documentos="cadastro.imovel.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Imóvel"
  )
</template>

<script>
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
import { mapActions } from 'vuex'
import AppImovelDenominacao from '../../../../components/cadastro/AppImovelDenominacao'
import AppImovelDadosTitulo from '../../../../components/cadastro/AppImovelDadosTitulo'
import AppMatriculaImovel from '../../../../components/AppMatriculaImovel'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppImovelDenominacao,
    AppMatriculaImovel,
    AppImovelDadosTitulo,
    AppDocumentos,
    AppLabel,
    AppDivider
  },

  props: ['cadastro', 'observer'],

  async beforeRouteLeave (to, from, next) {
    await this.setDocumentosInteressado()
    await this.observer.validate({ providerName: 'Imóvel/Documentos', skipIfEmpty: false })
    next()
  },

  data () {
    return {
      documentos: [],
      documentosObrigatorios: []
    }
  },

  async created () {
    await this.setDocumentosInteressado()
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    async setDocumentosInteressado () {
      this.documentos = await this.findDocumentos('imovelAforamento')
      this.documentosObrigatorios = await this.findDocumentos('obrigatorios/imovelAforamento')
    }
  }

}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}

@media (max-width: 780px) {
  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/resgateAforamento/components/Imovel.vue